import { EmperorTooltipOptions } from './models/tooltip.model';

export const defaultOptions: EmperorTooltipOptions = {
  placement: 'bottom',
  showDelay: 150,
  hideDelay: 0,
  animationDuration: 150,
  tooltipClass: '',
};
